import { createStyles } from 'antd-style';

import { ThemeFont } from '../../../theme';

export const useShipmentTemplatesListPopupStyles = createStyles(
  ({ token }) => ({
    shipmentTemplatesListPopup: {
      '&&': {
        color: token.colorPrimary,
        fontWeight: 'bold',

        [`@media (min-width: ${token.screenSMMin}px)`]: {
          fontSize: token.fontSizeLG,
        },
        [`@media (max-width: ${token.screenXSMax}px)`]: {
          fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        },
      },
    },
    shipmentTemplatesListPopupName: {
      [`@media (min-width: ${token.screenMDMin}px)`]: {
        maxWidth: 280,
      },
      [`@media (min-width: ${token.screenSMMin}px) and (max-width: ${token.screenSMMax}px)`]:
        {
          maxWidth: 174,
        },
      [`@media (max-width: ${token.screenXSMax}px)`]: {
        maxWidth: 119,
      },
    },
  })
);
